import React from 'react';
import { Select } from 'antd';
import { SelectContainer } from 'shared/styles';
import { useAppSelector } from 'shared/hooks';
import { Admin, EAdminRoles } from 'shared/types';
import { CLASS_PERIODS, UNASSIGNED_CLASS_PERIOD } from './constants';

type Props = {
  /** '' for all students, '1'-'8', or 'none' for students not in a period. */
  value: string;
  handlePeriodChange: (period: string) => void;
  disabled: boolean;
  /** Offer the "Not in a period" option (default true). */
  showUnassigned?: boolean;
};

/**
 * Filters students by the current teacher's class periods. Periods are
 * per-teacher, so like SchoolSelect (super admins only) this renders nothing
 * for other roles.
 */
const ClassPeriodSelect: React.FC<Props> = ({
  value,
  handlePeriodChange,
  disabled,
  showUnassigned = true,
}): JSX.Element | null => {
  const currentUser = useAppSelector((state): Admin | null => state.auth.user);

  if (currentUser?.role !== EAdminRoles.SCHOOL_ADMIN) return null;

  return (
    <SelectContainer style={{ width: '200px' }}>
      <Select
        style={{ width: '100%', marginBottom: '15px' }}
        onChange={handlePeriodChange}
        value={value ?? ''}
        disabled={disabled}
      >
        <Select.Option value=''>All periods</Select.Option>
        {showUnassigned && (
          <Select.Option value={UNASSIGNED_CLASS_PERIOD}>Not in a period</Select.Option>
        )}
        {CLASS_PERIODS.map((period): JSX.Element => (
          <Select.Option key={period} value={String(period)}>
            Period {period}
          </Select.Option>
        ))}
      </Select>
    </SelectContainer>
  );
};

export default ClassPeriodSelect;
